import 'core-js/stable';
import 'regenerator-runtime/runtime';
// import 'buefy/dist/buefy.css';
import './variables.scss';
import '@mdi/font/css/materialdesignicons.css';
import './tailwind.css';
import '@sweetalert2/theme-bulma/bulma.css';

import Vue from 'vue';
import VueMq from 'vue-mq';
import VueRouter from 'vue-router';
import Buefy from 'buefy';
import VueMasonry from 'vue-masonry-css'
import {sync} from 'vuex-router-sync';

import App from './App';
import router from './router';
import store from './store';
import validator from './validator';

Vue.use(VueRouter);

Vue.use(Buefy);

Vue.use(VueMq, {
    breakpoints: {
        xs: 640,
        sm: 768,
        md: 1024,
        lg: 1280,
        xl: 1600,
        xxl: Infinity,
    },
});

Vue.use(VueMasonry);

let unsync = sync(store, router);

new Vue({
    el: '#body',
    router,
    store,
    render: h => h(App),
    beforeDestroy() {
        unsync();
    },
});

if (!('localStorage' in window)) {
    window.localStorage = {
        _data: {},
        setItem: function (id, val) {
            return this._data[id] = String(val);
        },
        getItem: function (id) {
            return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
        },
        removeItem: function (id) {
            return delete this._data[id];
        },
        clear: function () {
            return this._data = {};
        }
    };
}

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};
